import React, { useState } from "react";
import { Mail, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { api, formatError } from "../lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="py-20 md:py-28 px-6 md:px-10 max-w-7xl mx-auto" data-testid="contact-page">
      <div className="overline mb-4">Get In Touch</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tight">Reach out to Lyon's Den.</h1>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div className="md:col-span-1 space-y-6 text-white/70">
          <div>
            <div className="overline text-[#D4AF37]">Email</div>
            <a href="mailto:info@lyonsdenprotection.com" className="block mt-2 hover:text-white"><Mail className="inline mr-2" size={14}/>info@lyonsdenprotection.com</a>
          </div>
          <div>
            <div className="overline text-[#D4AF37]">Based In</div>
            <div className="mt-2"><MapPin className="inline mr-2" size={14}/>Lafayette, Louisiana</div>
          </div>
          <div>
            <div className="overline text-[#D4AF37] mb-3">Follow</div>
            <div className="flex flex-col gap-2 text-sm">
              <a href="https://www.facebook.com/lyonsdenprotection" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] flex items-center gap-2"><Facebook size={14}/> Facebook</a>
              <a href="https://www.instagram.com/lyonsdenprotection" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] flex items-center gap-2"><Instagram size={14}/> Instagram</a>
              <a href="https://www.tiktok.com/@lyonsdenprotection" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37]">TikTok</a>
              <a href="https://www.youtube.com/@LyonsDenProtection" target="_blank" rel="noreferrer" className="hover:text-[#D4AF37] flex items-center gap-2"><Youtube size={14}/> YouTube</a>
            </div>
          </div>
          <div>
            <div className="overline text-[#D4AF37] mb-3">Policies</div>
            <div className="flex flex-col gap-2 text-sm text-white/70">
              <a href="/terms" className="hover:text-[#D4AF37]">Terms of Service</a>
              <a href="/refund-policy" className="hover:text-[#D4AF37]">Refund Policy</a>
              <a href="/cancellation-policy" className="hover:text-[#D4AF37]">Cancellation & Rescheduling</a>
              <a href="/disclaimer" className="hover:text-[#D4AF37]">Spiritual Disclaimer</a>
              <a href="/privacy" className="hover:text-[#D4AF37]">Privacy Policy</a>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6" data-testid="contact-form">
          <div>
            <label className="overline block mb-3">Name *</label>
            <input required name="name" value={form.name} onChange={onChange} className="w-full bg-transparent border-b border-white/20 py-3 focus:border-[#D4AF37] outline-none" data-testid="contact-name" />
          </div>
          <div>
            <label className="overline block mb-3">Email *</label>
            <input required type="email" name="email" value={form.email} onChange={onChange} className="w-full bg-transparent border-b border-white/20 py-3 focus:border-[#D4AF37] outline-none" data-testid="contact-email" />
          </div>
          <div className="md:col-span-2">
            <label className="overline block mb-3">Subject</label>
            <input name="subject" value={form.subject} onChange={onChange} className="w-full bg-transparent border-b border-white/20 py-3 focus:border-[#D4AF37] outline-none" data-testid="contact-subject" />
          </div>
          <div className="md:col-span-2">
            <label className="overline block mb-3">Message *</label>
            <textarea required rows={6} name="message" value={form.message} onChange={onChange} className="w-full bg-transparent border-b border-white/20 py-3 focus:border-[#D4AF37] outline-none" data-testid="contact-message" />
          </div>
          <div className="md:col-span-2">
            <button type="submit" disabled={loading} className="bg-[#8B0000] hover:bg-[#A50000] text-white px-10 py-4 text-xs uppercase tracking-[0.2em]" data-testid="contact-submit-btn">
              {loading ? "Sending…" : "Send Message"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
